import { ActivityTypeService } from 'app/services/activity-type';
import { ComboBox, IComboBoxOption } from 'office-ui-fabric-react';
import { useEffect, useState } from 'react';

type Props = {
  className?: string;
  onChange: (value: string) => void;
  value?: string;
};
const ArctivityTypeSelector: React.FC<Props> = ({
  className,
  onChange,
  value,
}) => {
  const [types, setTypes] = useState<IComboBoxOption[]>([]);
  useEffect(() => {
    const service = new ActivityTypeService();

    service
      .getActivityTypes({
        page: 1,
        pageSize: 1000,
        descending: false,
        language: 'tr',
      })
      .then((res) => {
        const types = res.data.attributes.list.map((item) => ({
          key: item.id as string,
          text: item.title,
        }));
        types.unshift({ key: '', text: 'Tümü' });
        setTypes(types);
      });
  }, []);

  return (
    <ComboBox
      className={className}
      options={types}
      selectedKey={value}
      onChange={(_, option) => {
        onChange(option?.key as string);
      }}
      label="Etkinlik Türü"
    />
  );
};

export default ArctivityTypeSelector;
